module.exports = __webpack_public_path__ + "static/paint-roller.512a426f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Page/img/paint-roller.png
// module id = 808
// module chunks = 118514840243029